export const REQUEST_USERS = "REQUEST_USERS";
export const SET_USERS = "SET_USERS";

export const LOGOUT_USER = "LOGOUT_USER";
export const REQUEST_LOGOUT_USER = "REQUEST_LOGOUT_USER";
